import { useNavigate } from "react-router-dom";
import { Megaphone, ChevronRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function AnnouncementBar({ preview = null }) {
  const { site } = useAuth();
  const navigate = useNavigate();
  const s = preview || site;
  if (!s?.announcement_active || !s?.announcement_text) return null;
  const color = s.announcement_color || "#EF4444";
  const link = (s.announcement_link || "").trim();

  const go = () => {
    if (preview || !link) return;
    if (/^https?:\/\//i.test(link)) window.open(link, "_blank", "noreferrer");
    else navigate(link.startsWith("/") ? link : `/info/${link}`);
  };

  return (
    <button
      type="button"
      data-testid="announcement-bar"
      onClick={go}
      className="w-full text-left sticky top-16 z-30 shadow-[0_10px_40px_-15px_rgba(239,68,68,0.8)]"
      style={{ backgroundColor: color }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2.5 flex items-center gap-3 text-white">
        <Megaphone className="h-4 w-4 shrink-0 animate-pulse" />
        <span className="font-display font-bold text-sm sm:text-base tracking-wide truncate" data-testid="announcement-text">{s.announcement_text}</span>
        {link && <ChevronRight className="h-4 w-4 ml-auto shrink-0" />}
      </div>
    </button>
  );
}
